import { render, staticRenderFns } from "./CourseStudentsManagement.vue?vue&type=template&id=6573caf6"
import script from "./CourseStudentsManagement.vue?vue&type=script&lang=ts"
export * from "./CourseStudentsManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports